import { Link, NavLink } from 'react-router-dom';
import { Settings } from 'lucide-react';
import EXHALE from '@/lib/testIds';

/**
 * Header — minimalist, almost invisible nav. Brand wordmark in Spectral,
 * three quiet links, a single settings icon.
 */
export default function Header({ onOpenSettings, hideOnSession = false }) {
  if (hideOnSession) return null;

  const link = ({ isActive }) =>
    `quiet-link ${isActive ? 'opacity-100' : 'opacity-60 hover:opacity-100'}`;

  return (
    <header className="relative z-20 px-6 sm:px-12 pt-8 sm:pt-10">
      <div className="mx-auto flex max-w-5xl items-center justify-between">
        <Link
          to="/"
          data-testid={EXHALE.brandLink}
          className="font-serif text-xl sm:text-2xl tracking-tight"
        >
          exhale<span className="text-sage">type</span>
        </Link>

        <nav className="flex items-center gap-7 sm:gap-10">
          <NavLink
            to="/modes"
            data-testid={EXHALE.navModes}
            className={link}
          >
            modes
          </NavLink>
          <NavLink
            to="/history"
            data-testid={EXHALE.navHistory}
            className={link}
          >
            history
          </NavLink>
          <button
            type="button"
            aria-label="Settings"
            data-testid={EXHALE.settingsBtn}
            onClick={onOpenSettings}
            className="opacity-60 hover:opacity-100 transition-opacity duration-500"
          >
            <Settings size={18} strokeWidth={1.25} />
          </button>
        </nav>
      </div>
    </header>
  );
}
